import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=87fe8d92&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=87fe8d92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe8d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fe8d92')) {
      api.createRecord('87fe8d92', component.options)
    } else {
      api.reload('87fe8d92', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=87fe8d92&scoped=true", function () {
      api.rerender('87fe8d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/avatar/avatar.vue"
export default component.exports